function InputNumber(props) {
    const numberInputOnWheelPreventChange = (e) => {
        // Prevent the input value change
        e.target.blur()

        // Prevent the page/container scrolling
        e.stopPropagation()

        // Refocus immediately, on the next tick (after the current  function is done)
        setTimeout(() => {
            e.target.focus()
        }, 0)
    }

    return(        
        <div className="mt-10">
            <label>{props.label}</label>
            <input 
                type="number" 
                min={props.min} 
                className="block w-full mt-3 p-3 border-solid border-gray-200 border-3 rounded-2xl" 
                value={props.value} 
                onChange={props.onChange}
                onWheel={numberInputOnWheelPreventChange} />
        </div>
    )
}

export default InputNumber;